import { useState } from 'react';

export const useDisclose = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);
  const set = (open: boolean) => setIsOpen(open);

  return { isOpen, onOpen, onClose, set };
};
